// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupingHeader__header___Lom3n,
.GroupingHeader__title___vt6jC,
.GroupingHeader__controls___dU8rd {
    display: flex;
    align-items: center;
}

.GroupingHeader__header___Lom3n {
    justify-content: space-between;
    padding-bottom: 0.4rem;
    border-bottom: 0.1rem solid var(--color-bg-border);
}

.GroupingHeader__title___vt6jC {
    gap: 1rem;
}

.GroupingHeader__controls___dU8rd {
    gap: 0.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalTemplate/ModalComponents/GroupingHeader/GroupingHeader.css"],"names":[],"mappings":"AAAA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf","sourcesContent":[".header,\n.title,\n.controls {\n    display: flex;\n    align-items: center;\n}\n\n.header {\n    justify-content: space-between;\n    padding-bottom: 0.4rem;\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n\n.title {\n    gap: 1rem;\n}\n\n.controls {\n    gap: 0.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `GroupingHeader__header___Lom3n`,
	"title": `GroupingHeader__title___vt6jC`,
	"controls": `GroupingHeader__controls___dU8rd`
};
export default ___CSS_LOADER_EXPORT___;
